export default __webpack_public_path__ + "media/images/react_icons/checkbox-c26146f93f4351a2872fe160310c91a1.svg";